// Este módulo representa todo lo que está mal sobre desarrollo web.
// Se supone que no hay que hacer userAgent spoofing ni platform
// spoofing, pero la realidad es que hay cosas que no puedes sacar
// por feature-detection, como por ejemplo si al poner un
// input type="number" saldrá un tipo de teclado u otro


// Inicializo todo lazy para evitar problemas en los tests de mocha
let initialized = false;

let _isFirefox = false;
let _isIE = false;
let _isWindows = false;
let _isAndroid = false;
let _isiOS = false;
let _isElectron = false;

function ensureInitialized() {
	if (initialized) return true;

	_isFirefox = !!navigator.userAgent.match(/Firefox/i);
	_isIE = !!navigator.userAgent.match(/Trident/i);

	_isWindows = navigator.platform === 'Win32' || navigator.platform === 'Win64';

	_isAndroid = !!navigator.userAgent.match(/Android/i);
	_isiOS = !!navigator.userAgent.match(/iphone|ipod|ipad/i);
	_isElectron = !!navigator.userAgent.match(/Electron/i);

	initialized = true;

	return true;
}


export const isFirefox = () => ensureInitialized() && _isFirefox;
export const isIE = () => ensureInitialized() && _isIE;
export const isWindows = () => ensureInitialized() && _isWindows;
export const isAndroid = () => ensureInitialized() && _isAndroid;
export const isiOS = () => ensureInitialized() && _isiOS;
export const isMobile = () => isAndroid() || isiOS();
export const isElectron = () => ensureInitialized() && _isElectron;
